/**
 * RHTimestampSorting
 *
 * The data view sorts a column by its raw field value compared as a *string*
 * (there is no dedicated "date" sort type). Canonical ISO timestamp strings sort
 * chronologically as strings, so for normally-created records (Mongoose
 * `timestamps`) a descending string sort already means "newest first".
 *
 * A few legacy/test records, however, carry a non-ISO date string (for example a
 * JS `Date.toString()` value such as "Thu Apr 17 2026 …"), which sorts out of
 * position because it does not start with the year. Normalising the sort-key
 * field to a canonical ISO string before handing the rows to the data view makes
 * the descending date sort correct and deterministic regardless of how the value
 * was stored.
 */
export class RHTimestampSorting {

    /**
     * Returns a canonical ISO-8601 string for any date-like value, or an empty
     * string for missing/unparseable values (which therefore sort last in a
     * descending order).
     */
        static sortableISOString(value: Date | string | number | null | undefined): string {
        if (value === undefined || value === null) {
            return ""
        }
        const date = new Date(value)
        const time = date.getTime()
        if (isNaN(time)) {
            return ""
        }
        return date.toISOString()
    }

}
